import { render, staticRenderFns } from "./groupChat.vue?vue&type=template&id=381f6e10"
import script from "./groupChat.vue?vue&type=script&lang=js"
export * from "./groupChat.vue?vue&type=script&lang=js"
import style0 from "./groupChat.vue?vue&type=style&index=0&id=381f6e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports